import {
    FETCH_LIST,
    LIST_FETCHED,
    SHOW_BONUS_COUPON_DIALOG,
    DELETE_BONUS_COUPON,
    TOGGLE_LOADING
  } from './actionTypes'
  
  export const fetchList = (params) => ({
    type: FETCH_LIST,
    payload: {
      params
    }
  })
  export const toggleLoading = () => ({
    type: TOGGLE_LOADING
  })
  export const listFetched = result => ({
    type: LIST_FETCHED,
    payload: result
  })

  export const showBonusCouponDialog = params => ({
    type: SHOW_BONUS_COUPON_DIALOG,
    payload: { params }
  })
  export const deleteBonusCoupon = (id,onSuccess) => ({
    type: DELETE_BONUS_COUPON,
    payload: { id,onSuccess }
  })
  